import { Injectable } from '@angular/core';
import { Acumatica, AcumaticaFieldFormat } from '../acumatica-field-decorator';
import { AcumaticaRequestOptions, AcumaticaService } from '../acumatica.service';
import { AcumaticaEntity, AcumaticaEntityService } from './acumatica-entity';
import { StockItem, StockItemService } from './StockItem.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PurchaseOrderService extends AcumaticaEntityService {
    constructor(
        acumatica: AcumaticaService,
    ) {
        super(acumatica, 'PurchaseOrder', PurchaseOrder);
    }

    get(OrderType: string, OrderNbr: string, options: AcumaticaRequestOptions = {}): Observable<PurchaseOrder> {
        return super.getEntity([OrderType, OrderNbr], {
            ...{ loader: "Getting Purchase Order" },
            ...options
        })
    }

    put(POOrder: PurchaseOrder, options: AcumaticaRequestOptions = {}): Observable<PurchaseOrder> {
        return new Observable<PurchaseOrder>(subscriber => {
            super.putEntity(POOrder, options).subscribe(
                POReceipt => {
                    subscriber.next(POReceipt)
                },
                error => {
                    subscriber.error(error);
                });
        });
    }
}

export class PurchaseOrderDetail extends AcumaticaEntity {
    @Acumatica() InventoryID!: string;
    @Acumatica() LineNbr!: number;
    @Acumatica() WarehouseID!: string;
    @Acumatica() OrderQty!: number;
    @Acumatica() QtyOnReceipts!: number;
    @Acumatica() UOM!: string;
}

export class PurchaseOrderReceiptDetail extends AcumaticaEntity {
    @Acumatica({ format: AcumaticaFieldFormat.Date }) Date!: Date;
    @Acumatica() ReceiptNbr!: string;
    @Acumatica() Status!: string;
    @Acumatica() Type!: string;
    @Acumatica() ReceivedQty!: number;
}

export class PurchaseOrder extends AcumaticaEntity {
    @Acumatica() note!: string;
    @Acumatica() Type!: string;
    @Acumatica() OrderNbr!: string;
    @Acumatica() Status!: string;
    @Acumatica() VendorID!: string;
    @Acumatica() VendorRef!: string;
    @Acumatica() Description!: string;
    @Acumatica({ format: AcumaticaFieldFormat.Date }) Date!: Date;

    @Acumatica(PurchaseOrderDetail) Details?: PurchaseOrderDetail[];
    @Acumatica(PurchaseOrderReceiptDetail) Receipts?: PurchaseOrderReceiptDetail[];
}